<template>
  <div class="bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area">
    <RolesGrid />
  </div>
</template>

<script>
import RolesGrid from "./RolesGrid";

export default {
  name: "roleslist",
  components: { RolesGrid }
};
</script>
